import React, { useMemo } from 'react'
import { Box, Grid } from '@material-ui/core'

import { StatsCard } from 'components'

import useCookieBanner from 'hooks/useCookieBanner'

import constants from 'constants/index'
import helpers from 'helpers'

const CookieStatsCard = () => {
  const { cookies } = useCookieBanner()

  const cookieStats = useMemo(
    () => helpers.cookies.banner.buildCookieStats(cookies),
    [cookies],
  )

  return (
    <Grid container spacing={2} component={Box} p={2} paddingRight={4}>
      {constants.cookies.category.COOKIE_STATS_CONFIG.map(
        ({ key, icon: Icon, label, backgroundColor }) => (
          <Grid item xs={12} sm={4} key={key}>
            <StatsCard
              icon={<Icon size={24} />}
              label={label}
              value={cookieStats[key]}
              backgroundColor={backgroundColor}
            />
          </Grid>
        ),
      )}
    </Grid>
  )
}

export default CookieStatsCard
